import { TaxonomyModalTabs } from "./TaxonomyModalTabs.component";

export { TaxonomyModalTabs };
